import { FormLabel } from "@mui/material";
import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { useSelector } from "react-redux";

function AllowedForQuant(props) {
    const { options, handleProServiceArray } = props;
    const { selectedProfServiceArray } = useSelector((state) => state.createOrderSlice)




    let value = selectedProfServiceArray?.filter(item => options?._id === item?.serviceId)[0]?.priceDetails?.quantity
    return (
        <React.Fragment>

            <Form.Select value={value ?? ''} className="NoDefault" aria-label="Default select example" onChange={(e) => handleProServiceArray({ "quantity": (e.target.value), "price": options?.ratePerService, "isQouteNeeded": options?.isQouteNeeded }, options)}>
                <option>Select Quantity</option>
                {Array.from(
                    {
                        length:
                            options?.maxQuantity + 1 - options?.minQuantity,
                    },
                    (v, index) => index
                ).map((number) => {
                    return (
                        <option

                            value={options?.minQuantity + number}
                        >
                            {options?.minQuantity + number}
                        </option>
                    );
                })}
            </Form.Select>
        </React.Fragment>
    );
}

export default AllowedForQuant;